function SearchArea(props: any) {
  let myProps = {
    listOpt: {},
    setListOpt: (inData: any) => { },
    get_word_by_ajax: (inData: any) => { },
    ...props
  };
  let listOpt = myProps.listOpt;

  return (
    <div className="my_flex_center">
      <select className="search-input" name="s_cont_part" value={listOpt.s_cont_part}
        onChange={(e) => {
          let change_list_opt: any = {
            s_cont_part: e.target.value
          };
          change_list_opt["s_cont_class"] = ["4-skills", "VOCA"];
          if (e.target.value == "word") {
            change_list_opt["s_cont_class"] = ["VOCA"];
          }
          myProps.get_word_by_ajax(change_list_opt);
        }}
      >
        {/* <option value="">단어,문장</option> */}
        <option value="word">단어</option>
        <option value="stc">문장</option>
      </select>
      <select className="search-input" name="s_include" value={listOpt.s_include}
        onChange={(e) => {
          myProps.get_word_by_ajax({
            s_include: e.target.value
          });
        }}
      >
        <option value="Y">사용</option>
        <option value="N">미사용</option>
      </select>
      <button className="btn btn-dark"
        onClick={() => {
          myProps.get_word_by_ajax({});
        }}>검색</button>
    </div>
  );
};
export default SearchArea;